import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Message } from 'types';
import ResponseRenderer from '../ResponseRenderer';

interface MessageListItemProps {
  message: Message;
}

const MessageListItem: React.FC<MessageListItemProps> = ({ message }) => {
  const isUser = message.role === 'user';

  const renderMessage = () => {
    // User messages
    if (isUser) {
      return <p className="whitespace-pre-wrap text-sm">{message.content}</p>;
    }

    if (message.agent_type) {
      // @ts-ignore
      const messageText = message.content.message || '';
      return (
        <>
          <div className="prose prose-sm max-w-none prose-headings:text-gray-900 prose-headings:font-semibold prose-headings:mt-4 prose-headings:mb-2 prose-p:text-gray-700 prose-p:my-2 prose-strong:text-gray-900 prose-ul:text-gray-700 prose-ul:my-2 prose-ol:text-gray-700 prose-ol:my-2 prose-li:my-1 prose-a:text-blue-600 hover:prose-a:text-blue-800">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                a: ({ href, children }) => (
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    {children}
                  </a>
                ),
              }}
            >
              {messageText}
            </ReactMarkdown>
          </div>
          <br />
          <ResponseRenderer agentType={message.agent_type} agentOutput={message.agent_output} />
        </>
      );
    }

    // Regular string messages from non-user (with markdown support)
    if (typeof message.content === 'string') {
      return (
        <div className="prose prose-sm max-w-none prose-headings:text-gray-900 prose-headings:font-semibold prose-headings:mt-4 prose-headings:mb-2 prose-p:text-gray-700 prose-p:my-2 prose-strong:text-gray-900 prose-ul:text-gray-700 prose-ul:my-2 prose-ol:text-gray-700 prose-ol:my-2 prose-li:my-1 prose-a:text-blue-600 hover:prose-a:text-blue-800">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ href, children }) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  {children}
                </a>
              ),
            }}
          >
            {message.content}
          </ReactMarkdown>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-3xl rounded-lg px-4 py-3 ${
          isUser ? 'bg-purple-600 text-white' : 'bg-white border border-gray-200 text-gray-900'
        }`}
      >
        {!isUser && (
          <div className="mb-2 pb-2 border-b border-gray-100">
            <p className="text-sm font-medium text-gray-700">Assistant</p>
          </div>
        )}
        {renderMessage()}
      </div>
    </div>
  );
};

export default MessageListItem;
